import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./utils/ErrorFallback";

import { Provider } from "react-redux";
// import WorstCaseScenario from "./utils/WorstCaseScenario";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // optional: reset state or navigate
        window.location.reload();
      }}
    >
      <App />
    </ErrorBoundary>
  </Provider>,
);
